import { notification } from "antd/lib";
import {
  changePreferredLanguage
} from "../../services/settingsService";
import { CHANGE_PREFERRED_LANGUAGE } from "../actionTypes";


export const changePreferredLanguageAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CHANGE_PREFERRED_LANGUAGE, payload: { loading: true } });
    const { data: body } = await changePreferredLanguage(payload);

    const { status, message, data } = body;

    if (status === 200) {
      notification.success({
        message: "Success",
        description: body.message,
      });
      dispatch({
        type: CHANGE_PREFERRED_LANGUAGE,
        payload: {
          loading: false,
          status: "success",
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: CHANGE_PREFERRED_LANGUAGE,
        payload: { loading: false, status: "error" },
      });
    }
  } catch (error) {
    dispatch({
      type: CHANGE_PREFERRED_LANGUAGE,
      payload: { loading: false, status: "error" },
    });
  }
};
